import {useQuery} from '@apollo/client/react';

import {graphql} from '../gqlApp';

/**
 * Права текущего пользователя в компании (SKS-15). Ими кабинет прячет действия,
 * которые бэкенд всё равно не даст выполнить, — не подсказываем кнопку, которая
 * упадёт с «Недостаточно прав». Источник истины — сервер, это лишь UX-слой.
 */
export const GET_MY_PERMISSIONS = graphql(`
	query MyPermissions($companyId: ID!) {
		myPermissions(companyId: $companyId)
	}
`);

export const useMyPermissions = (companyId: string | undefined) =>
	useQuery(GET_MY_PERMISSIONS, {
		variables: {companyId: companyId ?? ''},
		skip: !companyId,
	});
